// extracted by mini-css-extract-plugin
export default {"outer_cursor":"Cursor_outer_cursor__FNd2H","inner_cursor":"Cursor_inner_cursor__JQ32x","hover_project":"Cursor_hover_project__VG4Gw"};